module.exports = __webpack_public_path__ + "static/media/ISP-0059 - Administrative Penalty Order - GC King Bond - Amended.17e1ba04.pdf";